import BaseComponent from '../../base/base_component';
import Model from '../../components/loggedin/loggedin_model';
import _ from '../../utils/underscore';
import DOM from '../../utils/dom';
import * as LoggedinConsts from './loggedin_const';


class LoggedinComponentController extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'LoggedinComponentController';


    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = '#cgp_loggedin'; // LOGGEDIN_EVENTS_SELECTORS_ID.LOGGEDIN_CGP;


    /**
     * Root component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-loggedin-component';


    /**
     * @property
     * @type {Object}
     * @private
     */
    _layoutsContext = require.context('../../components/loggedin', true, /^.*(layout)\.js$/);


    /**
     * @property
     * @type {Array}
     * @private
     */
    _layouts = [];


    /**
     * @property
     * @type {*}
     * @private
     */
    _activeLayout = null;


    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;


    /**
     * @param params
     */
    init(params) {
        super.init(params);
        this._model = Model.create(params);
    }


    /**
     * Start the component view.
     *
     * @returns {LoginComponentController}
     * @public
     */
    start() {
        // init the component layouts
        this._initLayouts();
        let fnLayout = this._layouts.find(layout => this._isLayoutExist(layout.default.layoutName));

        if (!fnLayout) {
            this.logger.error('Loggedin component layout not set.');
            throw new Error();
        }

        this._changeLayout(fnLayout.default);

        return this;
    }


    /**
     * Set class define layout visual behaviour
     * @private
     */
    _setLayoutClass() {
        if (this._model.getPostLoginLayoutPC()) {
            DOM.addClass(this._activeLayout.getEl(), LoggedinConsts.POST_LOGIN_LAYOUT_CLASSES.PC[this._model.getPostLoginLayoutPC().toUpperCase()]);
        } else {
            DOM.addClass(this._activeLayout.getEl(), LoggedinConsts.POST_LOGIN_LAYOUT_CLASSES.PC.DEFAULT);
        }
        if (this._model.getPostLoginLayoutMobile()) {
            DOM.addClass(this._activeLayout.getEl(), LoggedinConsts.POST_LOGIN_LAYOUT_CLASSES.MOBILE[this._model.getPostLoginLayoutMobile().toUpperCase()]);
        } else {
            DOM.addClass(this._activeLayout.getEl(), LoggedinConsts.POST_LOGIN_LAYOUT_CLASSES.MOBILE.DEFAULT);
        }

    }


    /**
     *
     * @returns {*}
     * @public
     */
    getActiveLayout() {
        return this._activeLayout;
    }


    /**
     * @returns {LoginComponentController}
     * @private
     */
    _initLayouts() {
        // Get array of layouts.
        this._layouts = this._getLayoutsContext();

        return this;
    }


    /**
     * @returns {*}
     * @private
     */
    _getLayoutsContext() {
        if (!this._layoutsContext) {
            return [];
        }

        return this._layoutsContext.keys().map(this._layoutsContext);
    }


    /**
     * @param layoutName
     * @returns {boolean}
     * @private
     */
    _isLayoutExist(layoutName) {
        return layoutName === this._model.getLayout();
    }


    /**
     * Get environment
     *
     * @returns {*}
     */
    getEnvironment() {
        return this._model.getEnvironment();
    }


    /**
     * Change layout.
     *
     * @param layout
     * @private
     */
    _changeLayout(layout) {
        if (!_.isFunction(layout)) {
            this.logger.error('Layout must be an object type! --> ', typeof layout);
            throw new Error();
        }

        // There is active layout?
        if (this._activeLayout) {
            this.clear();
        }

        // Create layout instance.
        let layoutInstance = layout.create(Object.assign({}, {
            stepParent        : this,
            layoutType        : this._model.getLayoutType(),
            overlayPriority   : this._model.getOverlayPriority(),
            silentMode        : this._model.getSilentMode(),
            showCashier       : this._model.getShowCashier(),
            showMenu          : this._model.getShowMenu(),
            showBalance       : this._model.getShowBalance(),
            showUsername      : this._model.getShowUsername(),
            cashierOpenType   : this._model.getCashierOpenType(),
            showGreeting      : this._model.getPostLoginShowGreeting(),
            showUserBadge     : this._model.getShowUserBadge(),
            styleSelectors    : this.getStyleSelectors()
        },
        this._model.getMapByState(this._model.getLayout()))).start();
        // Set an new active layout.
        this._activeLayout = layoutInstance;

        // Get component global events to clear at the end of the component life cycle.
        this._systemEventsSubscriptions = this._systemEventsSubscriptions.concat(this._activeLayout._systemEventsSubscriptions);

        this._setLayoutClass();
        // Render layout.
        this.render(layoutInstance.getEl());
    }


    /**
     * @private
     */
    clear() {
        if (!this._activeLayout) {
            return;
        }
    }
}

export default LoggedinComponentController;